<template>
  <v-card flat>
    <v-card-text class="contract-renew-box" v-if="renewContract && getContract">
      <div class="col-1 space-between">
        <div>
          <div class="sub-title">{{ $t('contract.advance_contract_id_date', { date: getContract.renewEffectiveDateFormat }) }}</div>
          <div class="header"> {{ renewContract ? renewContract.contractId : "-" }}</div>
        </div>
        <div class="text-right">
          <v-chip :color="renewContract.status.color">{{ renewContract.status.text }}</v-chip>
          <div>{{ $t('contract.contract_created_at') }} {{ renewContract.createdAtFormat }}</div>
        </div>
      </div>
      <div class="col-2">
        <div>{{ $t('contract.business_name') }}</div>
        <div class="input-slot">{{ renewContract.businessName || "-" }}
        </div>
      </div>
      <div class="col-2">
        <div>{{ $t('market.rent_type') }}</div>
        <div class="input-slot"> {{ renewContract.stallTypeText }} </div>
      </div>
      <div class="col-3">
        <div>{{ $t('contract.start_date') }}</div>
        <div class="input-slot">{{ renewContract.startDateFormat }} </div>
      </div>
      <div class="col-3">
        <div>{{ $t('contract.end_date') }}</div>
        <div class="input-slot">{{ renewContract.endDateFormat }}</div>
      </div>
      <div class="col-3">
        <div>{{ $t('contract.contract_period') }} {{ renewContract.dayMonthYearText }}</div>
        <div class="input-slot">{{ renewContract.diffDays }} {{ $t('day') }}</div>
      </div>
      <div class="col-1 sub-title">Credit Term</div>
      <div class="col-flex">
        <div>{{ $t('market.due_date_after_bill') }}</div>
        <div class="input-slot">{{ $t('period') }} {{ renewContract.creditTerm || '-' }} {{ $t('day') }}</div>
        <div v-if="renewContract.creditTerm" class="input-slot">{{ $t('market.example_document_issue_date') }} {{
          $moment().format('DD MMM YYYY') }}</div>
        <div v-if="renewContract.creditTerm" class="input-slot">{{ $t('market.example_document_due_date') }} {{
          $moment().add(renewContract.creditTerm, 'days').format('DD MMM YYYY') }}</div>
      </div>
      <div class="col-1 sub-title">{{ $t('contract.contractor_information') }}</div>
      <div class="col-2">
        <div>{{ $t('customer.company_name_and_customer_name') }}</div>
        <div class="input-slot">{{ renewContract.billingDataName }}</div>
      </div>
      <div class="col-4">
        <div>{{ $t('address.company_branch') }}</div>
        <div class="input-slot">{{ renewContract.billingDataBranchName }}</div>
      </div>
      <div class="col-4">
        <div>{{ $t('tax.tax_id_number_another_form') }}</div>
        <div class="input-slot">{{ renewContract.billingDataTaxId }}</div>
      </div>
      <div class="col-2">
        <div>{{ $t('account.address') }}</div>
        <div class="input-slot">{{ renewContract.billingDataAddress }}</div>
      </div>
      <div class="col-4">
        <div>{{ $t('account.phone_number') }}</div>
        <div class="input-slot">{{ renewContract.billingDataTel }}</div>
      </div>
      <div class="col-4">
        <div>{{ $t('account.email') }}</div>
        <div class="input-slot">{{ renewContract.billingDataEmail }}</div>
      </div>
      <div class="col-1 sub-title">{{ $t('contract.rent_list_in_contract') }}</div>
      <div class="col-1">
        <AreasList :areas="renewContract.areas" :isShow="false" />
        <v-card v-if="!renewContract.areas || renewContract.areas.length < 1" class="mt-5 grey lighten-4" flat>
          <v-card-text>{{ $t('contract.no_stall_in_this_contract') }}</v-card-text>
        </v-card>
      </div>
      <div class="col-1 space-between sub-title">
        <h3>{{ $t('customer.document_set_list') }}</h3>
        <v-btn color="info" small elevation="0" @click="contractDocumentDialog($event, false)"
          :disabled="!renewContract.isActive">
          <v-icon left>mdi-plus-box</v-icon>{{ $t('contract.add_contract_document') }}
        </v-btn>
      </div>
      <div class="col-1">
        <CardContractDocument v-for="(doc, index) of renewContractDocuments" :key="`doc_${index}`"
          :indexNumber="`${index + 1}`" :object="doc" @onView="contractDocumentDialog(doc, true, true)"
          @onUpdated="contractDocumentDialog(doc, true)" @onRemove="contractDocumentRemoveDialog(doc)" :isDisabled="true"/>
        <CardContractDocument v-if="renewContractDocuments.length < 1" :isNull="true" />
      </div>
      <div class="col-1">
        <v-btn color="primary" disabled>
          <v-icon left>mdi-file-edit</v-icon>{{ $t('contract.edit_contract') }}
        </v-btn>
        <v-btn color="error" @click="isConfirmCancelRenewContract = true" class="ms-2" :disabled="isLoading">
          {{ $t('contract.cancel_renew_contract') }}
        </v-btn>
      </div>
    </v-card-text>
    <ContractDocument v-model="isContractDocument" :projectId="projectId" :marketId="marketId"
      :contract-id="renewContract.objectId || null" :isUpdate="isContractDocumentUpdate" :object-id="contractDocumentId"
      :isDisable="isContractDocumentDisable" />
    <ConfirmDialogComponent v-model="isConfirmContractDocumentRemove" @onOk="contractDocumentRemove"
      :title="$t('validate.you_want_to_delete_this_document_set')" type="error" />
    <ConfirmDialogComponent v-model="isConfirmCancelRenewContract" @onOk="cancelRenewContract"
      :title="$t('validate.you_want_to_cancel_renew_contract')" type="error" />
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import AreasList from "./AreasList.vue";
import ContractDocument from "./ContractDocument.vue";
import CardContractDocument from "./CardContractDocument.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
export default {
  name: "RenewContractDetail",
  created() { },
  components: {
    AreasList,
    ContractDocument,
    CardContractDocument,
    ConfirmDialogComponent
  },
  computed: {
    ...mapGetters({
      getContract: "contract/getContract",
    }),
    renewContract() {
      let renewContract
      if (this.getContract && this.getContract.renewEffectiveDate && this.getContract.renewEffectiveContract) renewContract = this.getContract.renewEffectiveContract
      return renewContract
    }
  },
  watch: {
    renewContract: {
      handler(value) {
        if (value.objectId) this.loadContractDocuments(value.objectId)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      marketId: this.$route.params.marketId,

      renewContractDocuments: [],
      isLoadContractDocument: false,

      isContractDocument: false,
      isConfirmContractDocumentRemove: false,
      isContractDocumentUpdate: false,
      isContractDocumentDisable: false,
      contractDocumentId: '',
      isLoading: false,
      isConfirmCancelRenewContract: false
    };
  },
  methods: {
    ...mapActions({
      getContractDocuments: 'contractDocument/getContractDocuments',
      removeContractDocument: 'contractDocument/removeContractDocument'
    }),
    async loadContractDocuments(contractId) {
      if (contractId) {
        this.isLoadContractDocument = true
        this.renewContractDocuments = await this.getContractDocuments({
          contractId: contractId,
          isRenewContract: true
        });
        this.isLoadContractDocument = false
      }
    },
    contractDocumentDialog(e, isUpdate = false, isDisable = false) {
      this.isContractDocumentUpdate = isUpdate || false;
      this.isContractDocumentDisable = isDisable || false;
      if (isUpdate) {
        this.contractDocumentId = e.objectId;
      }
      this.isContractDocument = true;
    },
    contractDocumentRemoveDialog(item) {
      this.isConfirmContractDocumentRemove = true;
      this.contractDocumentId = item.objectId;
    },
    async contractDocumentRemove() {
      await this.removeContractDocument({ id: this.contractDocumentId });
      if (this.renewContract) this.loadContractDocuments(this.renewContract.objectId);
    },
    async cancelRenewContract() {
      this.isLoading = true
      this.isConfirmCancelRenewContract = false
      try {
        await this.$store.dispatch("contract/cancelRenewContract", { id: this.getContract.objectId });
        this.$emit("onCancelRenewContract");
        this.$toast.show({
          content: this.$t('contract.cancel_renew_contract_success'),
          color: "success"
        });
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contract-renew-box {
  display: flex;
  flex-wrap: wrap;

  .input-slot {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    border-radius: 4px;
    padding: 12px;
    margin: 0;
  }

  .header {
    font-size: 25px;
    padding: 10px 0;
  }

  .sub-title {
    font-size: 18px;
  }

  @for $i from 1 through 5 {
    $colum-size : 100% / ($i);

    .col-#{($i)} {
      width: $colum-size;
      max-width: $colum-size;
      flex-basis: $colum-size;
      min-width: 250px;
    }

    .sub-title.col-#{($i)} {
      margin-top: 15px;
    }
  }
  .col-flex{
    display: flex;
    align-items: center;
    div{
      margin-left: 15px;
    }
  }

  .space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;

      .v-chip {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
